export const WHATSAPP_NUMBER = '447345197820'

/** WhatsApp chat link with a prefilled (URL-encoded) message. */
export function whatsAppLink(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}
